module.exports = __webpack_public_path__ + "img/7.564ee3f7.jpg";